import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import AboutUs from "@/pages/AboutUs";

export const Route = createFileRoute("/by/about-us")({
  head: () => routeHead('Пра AGAPE — Каманда і падыход', META_DESCRIPTIONS.about.by, '/by/about-us'),
  component: AboutUs,
});
